import { useEffect, useState } from "react";

const useDocumentVisible = (): boolean => {
  const [documentVisible, setDocumentVisible] = useState<boolean>(true);

  useEffect(() => {
    const onVisibilityChange = () =>
      setDocumentVisible(document.visibilityState === "visible");

    document.addEventListener("visibilitychange", onVisibilityChange);

    return () =>
      document.removeEventListener("visibilitychange", onVisibilityChange);
  }, []);
  return documentVisible;
};

export default useDocumentVisible;
